import React from 'react';

import logoInove from '../../assets/logoInove.svg';
import './styles.css';

const Footer = () => {
    return (        
        <div id="rodape">
            <p>Suporte Técnico</p>
            <p id="fones">(87) 99965-6771 (WhatsApp)</p>
            <p>Seg. a Sex. das 08:00h às 18:00h e Sáb. das 08:00h às 12:00h</p>
            <br/>
            <a href="https://loja.inovesistemas.info"><img id="logoInove" src={logoInove} alt=""/></a>
        </div>
    )
} 

export default Footer;